import React from "react";
import styled from "styled-components";
import Button from "./Button/v2";
import { formatRoleBreakdownAsList } from "core/utils/roles";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
`;

const ConfirmModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.95);
  border: 2px solid #ff8c00;
  border-radius: 10px;
  padding: 2rem;
  z-index: 1000;
  text-align: center;
  min-width: 300px;
  max-width: 500px;
`;

const ModalText = styled.p`
  color: white;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

const RoleList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 1rem 0;
  text-align: left;

  li {
    color: white;
    padding: 0.5rem;
    margin: 0.25rem 0;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
  }
`;

const WarningText = styled.strong`
  color: #ff8c00;
  display: block;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const RoleConfirmationModal = ({
  breakdown,
  currentPlayerCount,
  onConfirm,
  onCancel,
  onRandomize,
}) => {
  if (!breakdown) return null;

  const { willBeAssigned, totalConfigured, needsRandomization } = breakdown;
  const rolesList = formatRoleBreakdownAsList(willBeAssigned);

  return (
    <>
      <Overlay onClick={onCancel} />
      <ConfirmModal data-test-id="role-confirmation-modal">
        <ModalText>
          You have {currentPlayerCount} players, but configured roles for{" "}
          {totalConfigured}.
        </ModalText>
        <ModalText>
          The following roles will be assigned:
          <RoleList>
            {rolesList.map((role, index) => (
              <li key={index}>{role}</li>
            ))}
          </RoleList>
        </ModalText>
        {needsRandomization && (
          <WarningText>Some roles will be randomly selected</WarningText>
        )}
        <ButtonRow>
          <Button
            onClick={onRandomize}
            data-test-id="randomize-button"
            backGroundColor="#ff8c00"
          >
            Randomize
          </Button>
          <Button
            onClick={onConfirm}
            data-test-id="confirm-start-button"
            backGroundColor="#228833"
          >
            Start Game
          </Button>
          <Button
            onClick={onCancel}
            data-test-id="cancel-start-button"
            backGroundColor="#666666"
          >
            Cancel
          </Button>
        </ButtonRow>
      </ConfirmModal>
    </>
  );
};

export default RoleConfirmationModal;
